import {
  START_CHECKOUT,
  START_CHECKOUT_SUCCESS,
  START_CHECKOUT_ERROR,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_ERROR,
  REACTIVATE_SUBSCRIPTION,
  REACTIVATE_SUBSCRIPTION_SUCCESS,
  REACTIVATE_SUBSCRIPTION_ERROR,
} from './constants';

const initialState = {
  checkoutLoading: false,
  checkoutError: null,
  canceling: false,
  cancelSuccess: null,
  cancelError: null,
};

export default function stripeReducer(state = initialState, action) {
  switch (action.type) {
    case START_CHECKOUT:
      return {
        ...state,
        checkoutLoading: true,
        checkoutError: null,
      };
    case START_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkoutLoading: false,
        checkoutError: null,
      };
    case START_CHECKOUT_ERROR:
      return {
        ...state,
        checkoutLoading: false,
        checkoutError: action.error,
      };
    case CANCEL_SUBSCRIPTION:
      return {
        ...state,
        canceling: true,
        cancelSuccess: null,
        cancelError: null,
      };

    case CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        canceling: false,
        cancelSuccess: action.successMessage,
        cancelError: null,
      };

    case CANCEL_SUBSCRIPTION_ERROR:
      return {
        ...state,
        canceling: false,
        cancelSuccess: null,
        cancelError: action.error,
      };
    case REACTIVATE_SUBSCRIPTION:
      return {
        ...state,
        canceling: true,
        cancelSuccess: null,
        cancelError: null,
      };

    case REACTIVATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        canceling: false,
        cancelSuccess: action.successMessage,
        cancelError: null,
      };

    case REACTIVATE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        canceling: false,
        cancelSuccess: null,
        cancelError: action.error,
      };
    default:
      return state;
  }
}
